// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"edd35634","703":"49f7108c","787":"a011d2c8"}[chunkId] + ".chunk.js";
};